import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.colors.white};
    border-bottom: 1px solid ${props => props.theme.colors.neutral50};
    padding: 14px 0px;

    .container-logo-steps{
      max-width: 1440px;
      width: 100%;
      display: flex;

      @media (max-width: 768px) {
        flex-direction: column;
        a{
          justify-content: center;
        }
      }
    }
`;

export const StyledLinkLogo = styled(Link)`
    float: left;
    display: flex;
    align-items: center;

    img {
      width: 134px;
    }
`;

export const Steps = styled.div`
    display: flex;
    flex-direction: row;
    height: 100px;
    position: relative;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    margin-right: 134px;

    div.line{
        z-index: 1;
        position: absolute;
        width: 222px;
        height: 3px;
        background: ${props => props.theme.colors.neutral100};
        display: flex;
        align-self: center;
        left: calc(50% - 111px);
    }

    div.lineEvo {
        background: ${props => props.theme.colors.primary};
        height: 3px;
        position: absolute;
        display: flex;
        align-self: center;
        z-index: 1;
        left: calc(50% - 111px);
    }

    @media (max-width: 768px) {
      margin-right: 0;
    }
`;

export const StepCircle = styled.div`
    z-index: 2;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${props => props.theme.colors.white};
    border: 2px solid ${props => props.theme.colors.neutral200};
    transition: background 200ms ease, border-color 200ms ease, color 200ms ease;

    &:not(:last-child) {
        margin-right: 50px;
    }

    svg {
        width: 22px;
        height: 22px;
        color: ${props => props.theme.colors.neutral400};
    }

    &.active {
        background: ${props => props.theme.colors.primary};
        border-color: ${props => props.theme.colors.primary};

        svg {
            color: ${props => props.theme.colors.white};
        }
    }
`;
